const GERMAN_TIME_ZONE = "Europe/Berlin";

const germanDateTimeFormatter = new Intl.DateTimeFormat("de-DE", {
  dateStyle: "medium",
  timeStyle: "short",
  timeZone: GERMAN_TIME_ZONE,
});

const germanDateFormatter = new Intl.DateTimeFormat("de-DE", {
  dateStyle: "medium",
  timeZone: GERMAN_TIME_ZONE,
});

const germanExportFormatter = new Intl.DateTimeFormat("de-DE", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hourCycle: "h23",
  timeZone: GERMAN_TIME_ZONE,
});

const germanDateKeyFormatter = new Intl.DateTimeFormat("en-CA", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  timeZone: GERMAN_TIME_ZONE,
});

export const formatGermanDateTime = (value: string | Date) =>
  germanDateTimeFormatter.format(new Date(value));

export const formatGermanDate = (value: string | Date) =>
  germanDateFormatter.format(new Date(value));

export const formatGermanDateTimeForExport = (value: string | Date) => {
  const parts = germanExportFormatter.formatToParts(new Date(value));
  const getPart = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? "";

  return `${getPart("day")}.${getPart("month")}.${getPart("year")} ${getPart("hour")}:${getPart("minute")}:${getPart("second")}`;
};

export const getGermanDateKey = (value: string | Date) =>
  germanDateKeyFormatter.format(new Date(value));
